import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Filter from "./Filter";
import Table from "./Table";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCustomerReport,
  GetExturnalauditReport,
} from "../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../features/admin/external_audit/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const External_Audit = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  const [searchParams, setSearchParams] = useState({
    start_date: "",
    end_date: "",
    status_id: "",
    name: "",
  });

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReportPermission = permissions?.includes(
    FixIDS.external_audit_report.Report,
  );

  const externalauditdetails = useSelector((state) => state?.external_audit);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: externalauditdetails.per_page,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        status_id: searchParams?.status_id?.value,
        name: searchParams?.name,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [dispatch, currentPage, searchParams]);
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetExturnalauditReport({
        page: 1,
        per_page: externalauditdetails.per_page,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        status_id: searchParams?.status_id?.value,
        name: searchParams?.name,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="External Audit Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            externalauditdetails={externalauditdetails}
          />
        )}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"External Audit Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default External_Audit;
